import React from 'react';
import { useTheme } from 'styled-components';
import { Select as UiSelect, SelectCreatable as UiSelectCreatable, SelectAsync as UiSelectAsync, SelectAsyncCreatable as UiSelectAsyncCreatable } from './../../select';
import { getColor, getColorShade, getSizeBy } from '../../../../src/styled/utils';
import { groupRadius } from '../../../styled/utils';
const hintColors = {
    success: 'success',
    warning: 'warning',
    error: 'danger',
    info: 'onSurface'
};
function getBorderColor(isFocused, hintType) {
    if (hintType) {
        return getColor(hintColors[hintType]);
    }
    if (isFocused) {
        return getColor('primary');
    }
    return getColorShade('onSurface', 'outline');
}
function generateStyles(theme, 
/* Size 'extraLarge' is deprecated, use large instead */
size, hintType, prefixIcon, groupPosition) {
    return {
        control(provided, { isFocused, isDisabled }) {
            return {
                ...provided,
                color: getColor('onSurface')({ theme }),
                minHeight: getSizeBy(9, size)({ theme }),
                borderRadius: groupRadius(groupPosition)({ theme }),
                borderWidth: 1,
                backgroundColor: isDisabled
                    ? getColorShade('onSurface', 'hover')({ theme })
                    : getColor('surface')({ theme }),
                borderColor: getBorderColor(isFocused, hintType)({ theme }),
                boxShadow: 'none',
                '&:hover': isFocused || isDisabled || hintType
                    ? {}
                    : {
                        borderColor: getColorShade('onSurface', 'mediumEmphasis')({ theme })
                    }
            };
        }
    };
}
function selectHoc(Component) {
    // TODO: use T
    return (props) => {
        var _a, _b;
        const theme = useTheme();
        const styles = {
            ...generateStyles(theme, (_a = props.size) !== null && _a !== void 0 ? _a : 'medium', props.hintType, props.prefixIcon, props.groupPosition),
            ...((_b = props.styles) !== null && _b !== void 0 ? _b : {})
        };
        return React.createElement(Component, { ...props, styles: styles });
    };
}
export const Select = selectHoc(UiSelect);
export const SelectCreatable = selectHoc(UiSelectCreatable);
export const SelectAsync = selectHoc(UiSelectAsync);
export const SelectAsyncCreatable = selectHoc(UiSelectAsyncCreatable);
